import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import React from 'react';
import { createUseStyles } from 'react-jss';
//import { get, find, toNumber, isEmpty } from 'lodash-es';
//import { differenceInSeconds } from 'date-fns';
import JoulpointMap from '../map/JoulepointMap';

const useStyles = createUseStyles({
  modal: {
    '& .modal-content': {
      width: '700px',
    },
    '& .modal-title': {
      fontSize: '17px',
    },
  },
});

export default function ChargerLocationModal({
  toggleModalOpen,
  modalOpen,
  selectedCharger,
}) {
  const classes = useStyles();
  /* function isChargerOnline() {
    const { LAST_HEARTBEAT } = selectedCharger;
    const chargerConfig = isEmpty(selectedCharger)
      ? selectedCharger
      : JSON.parse(get(selectedCharger, 'CHARGER_CONFIGURATION'));

    const chargerHearBeatConfigObj = find(
      get(chargerConfig, 'configurationKey'),
      { key: 'HeartbeatInterval' },
    );
    const chargerHeartBeatInterval = toNumber(
      get(chargerHearBeatConfigObj, 'value'),
    );
    const diffInSeconds = differenceInSeconds(
      new Date(),
      new Date(LAST_HEARTBEAT),
    );
    return diffInSeconds <= chargerHeartBeatInterval;
  } */

  return (
    <Modal
      isOpen={modalOpen}
      toggle={toggleModalOpen}
      className={classes.modal}
    >
      <ModalHeader toggle={toggleModalOpen}>
        Charger {selectedCharger.ID}
      </ModalHeader>
      <ModalBody style={{ marginTop: '-30px' }}>
        <JoulpointMap mapType="chargers" records={[selectedCharger]} />
      </ModalBody>
    </Modal>
  );
}
